import axios from 'axios';
import { authHeader } from './authservice/auth-header';

// const ELASTIC_API = process.env.VUE_APP_ELASTIC_API;
const API_URL = process.env.VUE_APP_BASE_API_URL;

class StatisticService {
    getTotalUser() {
        return axios.get(API_URL+'statistic/total-user', { headers: authHeader() });
    }
    getTotalTarget() {
        return axios.get(API_URL+'statistic/total-target', { headers: authHeader() });
    }

    getTotalTargetBy() {
        return axios.get(API_URL+'statistic/total-target-by', { headers: authHeader() });
    }

    getTotalCategoryBy() {
        return axios.get(API_URL+'statistic/total-category-by', { headers: authHeader() });
    }

    getDailyTargetBy() {
        return axios.get(API_URL+'statistic/daily-target-by', { headers: authHeader() });
    }

    getDailyTarget() {
        return axios.get(API_URL+'statistic/daily-target', { headers: authHeader() });
    }
    getTotalTwitter() {
        return axios.get(API_URL+'statistic/total-twitter', { headers: authHeader() });
    }
    getTotalInstagram() {
        return axios.get(API_URL+'statistic/total-instagram', { headers: authHeader() });
    }


    // statistic
    getTotalCitizen(ip, data) {
        return axios.post(ip + 'minduk/_search?scroll=1m', data, { headers: {'Content-Type': 'application/json'} });
    }

    getTotalCitizenDate(ip, data) {
        return axios.post(ip + 'minduk/_search?scroll=1m&filter_path=hits', data, { headers: {'Content-Type': 'application/json'} });
    }

    getTotalFacebook(ip, data) {
        return axios.post(ip + 'facebook/_search?scroll=1m', data, { headers: {'Content-Type': 'application/json'} });
    }

    getTotalFacebookdate(ip, data) {
        return axios.post(ip + 'facebook/_search?scroll=1m&filter_path=hits', data, { headers: {'Content-Type': 'application/json'} });
    }

    getTotalTokopedia(ip, data) {
        return axios.post(ip + 'tokopedia/_search?scroll=1m', data, { headers: {'Content-Type': 'application/json'} });
    }

    getTotalTokopediaDate(ip, data) {
        return axios.post(ip + 'tokopedia/_search?scroll=1m&filter_path=hits', data, { headers: {'Content-Type': 'application/json'} });
    }

    getTotalGroupTele(ip, data) {
        return axios.post(ip + 'osint_group_list/_search?scroll=1m', data, { headers: {'Content-Type': 'application/json'} });
    } 
}

export default new StatisticService();
